class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState?.key || null;

    try {
      this.getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        const sectionHtml = parsedState?.sections?.[section.id];
        if (!container || !sectionHtml) return;

        container.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      });

      if (this.header) this.header.reveal();
      this.open();
    } catch (e) {
      console.warn('[cart-notification] fallback render', e);
    }
  }

  getSectionsToRender() {
    const hasKey = Boolean(this.cartItemKey);

    const productSelector = hasKey
      ? `[id="cart-notification-product-${this.cartItemKey}"]`
      : '.shopify-section';

    return [
      {
        id: 'cart-notification-product',
        selector: productSelector,
      },
      {
        id: 'cart-notification-button',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    let node = selector ? doc.querySelector(selector) : null;
    if (!node) node = doc.querySelector('.shopify-section');
    return node ? node.innerHTML : html;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
